import { usePresentationMode } from '@euler/app/components/PresentationModeContext';
import {
  LoginSide,
  useLoginLayout,
} from '@euler/app/flows/auth/components/LoginScreenView';
import { LoginCodeScreen } from '@euler/app/flows/auth/pages/Code';
import { LoginCodeTipsScreen } from '@euler/app/flows/auth/pages/CodeTips';
import { LoginScreen } from '@euler/app/flows/auth/pages/Login';
import { LoginPhoneScreen } from '@euler/app/flows/auth/pages/Phone';
import { QrcodeLoginScreen } from '@euler/app/flows/auth/pages/Qrcode';
import { AppSelectionScreen } from '@euler/app/flows/auth/pages/AppSelection';
import { QrcodeScanScreen } from '@euler/app/flows/common/QrcodeScanScreen';
import { rpxHub } from '@euler/app/tv/functions/utils';
import { usePresentationTheme } from '@euler/app/tv/theme';
import {
  ResponsiveContextProvider,
  useResponsiveContext,
} from '@euler/functions/responsive/ResponsiveContext';
import { PixelScaleFn } from '@euler/functions/responsive/utils';
import { ScreenToParams, spreadScreens } from '@euler/functions/spreadScreens';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { createStackNavigator } from '@react-navigation/stack';
import { memo, useMemo } from 'react';
import { View } from 'react-native';

const AuthStack = createStackNavigator();
export type AuthNavParams = ScreenToParams<typeof AuthScreens>;

export const AuthScreens = {
  Login: LoginScreen,
  _LoginPhone: LoginPhoneScreen,
  _LoginCode: LoginCodeScreen,
  _LoginCodeTips: LoginCodeTipsScreen,
  _qrcodeScan: QrcodeScanScreen,
  _qrcodeChallenge: QrcodeLoginScreen,
  _AppSelection: AppSelectionScreen,
};

export const Screens = memo(() => {
  const presentationMode = usePresentationMode();
  const presentationTheme = usePresentationTheme();
  const { rpx } = useResponsiveContext();
  const scaled: PixelScaleFn = useMemo(
    () => value => {
      return presentationMode === 'presentation'
        ? rpxHub(value * 2)
        : rpx(value);
    },
    [presentationMode, rpx],
  );

  return (
    <ResponsiveContextProvider scaled={scaled}>
      <AuthStack.Navigator
        screenOptions={{
          headerShown: false,
          cardStyle: {
            backgroundColor:
              presentationMode === 'presentation'
                ? presentationTheme.page.bg
                : undefined,
          },
        }}
      >
        {spreadScreens(AuthStack.Screen, AuthScreens)}
      </AuthStack.Navigator>
    </ResponsiveContextProvider>
  );
});

export const AuthScreen = wrapNavigatorScreen(() => {
  const { sideWidth, showSidebar } = useLoginLayout();

  if (!showSidebar) {
    return <Screens />;
  }

  return (
    <View
      css={`
        flex: 1;
        flex-direction: row;
        align-items: stretch;
        justify-content: flex-start;
      `}
    >
      <LoginSide width={sideWidth} />
      <View
        css={`
          flex: 1;
        `}
      >
        <Screens />
      </View>
    </View>
  );
});
